
const FeedbackData = [
    {
      id: 1,
      rating: 10,
      text: 'Add here your review =) ',
    },
  ]
  
  export default FeedbackData